import React, { Fragment } from 'react';
import Grid from 'ui/antd/Grid';
import Button from 'ui/antd/Button';
import Avatar from 'ui/antd/Avatar';
import userIcon from 'images/user-icon.png';
import './styles.scss';
import { withTheme } from 'providers';
import { UIContainerLayout } from 'ui/Layout'
import { Analytics } from 'utilities';
import { routes } from '../../../../shared/constants/routes';

const { Row, Col } = Grid;

function MessageLines({ name = '' }) {
  const lines = [
    'Check your inbox! We\'ve sent you an email to verify your email address. Please verify your email address so your message can be sent to the resident.',
    `Please keep in mind that ${name} is an actual apartment renter, not a chat bot. It may take them a few moments to respond to your message.`,
    `The views and opinions expressed by these residents are theirs and theirs alone. They are not representatives of the management company or Rentgrata.`,
    'Thank you for joining our community.',
  ];

  return (
    <Col className="newUserConfirmation__messsage-lines">
      {
        lines.map((line, i) =>
          <p key={i}>{line}</p>)
      }
    </Col>

  )
}

function NewUserConfirmation(props) {
  let {
    location: { state: { resident } = { resident: { first_name: '' } } },
    context: { theme },
  } = props;

  Analytics.pageView('/confirm-email');

  return (
    <UIContainerLayout>
      <>
        <Row className={`newUserConfirmation ${theme}`}>
          <Col className="newUserConfirmation__header">
            <h3>Thank you for using Rentgrata!</h3>
          </Col>

          <Row type="flex" justify="center">
            <Avatar size={80} src={resident.image_url || userIcon} />
          </Row>

          <Row className="newUserConfirmation__messsage">
            <MessageLines name={resident.first_name} />

            <Col className="newUserConfirmation__messsage-btn">
              <Button label="Okay" block onClick={() => {
                return props.history.push(routes.RESIDENT_LIST);
              }} />
            </Col>
          </Row>
        </Row>
      </>
    </UIContainerLayout>
  )
}

export default withTheme(NewUserConfirmation);
